import { useTranslation } from "react-i18next";
import { skipToken } from "@reduxjs/toolkit/query";

import { useGetUserByIdQuery } from "@/redux/service";
import { formatCertificationDate } from "@/domains/certifications/utils";
import { CaseDecisionProps } from "@/features/community/moderation/types";
import {
  MODERATION_DECISION_SOURCES,
  MODERATION_STATES,
} from "@/domains/moderation/constants";

import "../styles.css";

const DecidedNote = ({ moderationCase }: CaseDecisionProps) => {
  const { t } = useTranslation();
  const { decidedBy, decidedAt, decisionSource, publicFeedback, state } =
    moderationCase;
  const admin = useGetUserByIdQuery(decidedBy ?? skipToken);

  let decider = t("moderation.case.decidedBy.automatically");
  if (decisionSource === MODERATION_DECISION_SOURCES.AI) {
    decider = t("moderation.case.decidedBy.ai");
  } else if (decidedBy !== null) {
    decider =
      admin.data?.fullName.trim() ||
      admin.data?.email ||
      t("moderation.case.decidedBy.anAdmin");
  }
  const outcome = state === MODERATION_STATES.REJECTED ? "removed" : "approved";

  return (
    <div className="flex flex-col gap-50">
      <span className="moderation-muted body-s-regular">
        {decidedAt
          ? t(`moderation.case.decided.${outcome}`, {
              name: decider,
              date: formatCertificationDate(decidedAt),
            })
          : t(`moderation.case.decided.${outcome}NoDate`, { name: decider })}
      </span>

      {publicFeedback && (
        <p className="moderation-note body-s-regular">
          {t("moderation.case.feedbackSent", { feedback: publicFeedback })}
        </p>
      )}
    </div>
  );
};

export default DecidedNote;
